<template>
    <KRHPTyhiPaigutus>
      <template #body>
        <v-row>
          <v-col>
            <Ligipaasetavus/>
          </v-col>
        </v-row>
      </template>
    </KRHPTyhiPaigutus>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import KRHPTyhiPaigutus from "@/components/uldine/KRHPTyhiPaigutus.vue";
import Ligipaasetavus from "@/components/ligipaasetavus/Ligipaasetavus.vue";

export default defineComponent({
    name: 'LigipaasetavusTyhiPaigutusLeht',
    components: {Ligipaasetavus, KRHPTyhiPaigutus }
})
</script>

<style scoped>

</style>